import React, {useContext, useState, ReactNode} from "react";
import {Snackbar} from "@mui/material";
import {Alert, AlertProps} from "@mui/lab";
import {RTL} from "../cache/CacheRtl";

type Severity = NonNullable<AlertProps["severity"]>;

interface NotificationHandler {
  success: (message: string) => void;
  error: (message: string) => void;
  info: (message: string) => void;
  warning: (message: string) => void;
}

interface MessageContextValue {
  notificationHandler: NotificationHandler;
}

interface SnackState {
  open: boolean;
  severity: Severity;
  msg: string;
}

const MessageContext = React.createContext<MessageContextValue | undefined>(undefined);

export function useMessageContext(): MessageContextValue | undefined {
  return useContext(MessageContext);
}

export function MessageProvider({children}: {children?: ReactNode}) {
  const [snackOpen, setSnackOpen] = useState<SnackState>({
    open: false,
    severity: 'info',
    msg: ''
  });


  const notificationHandler: NotificationHandler = {
    success: message => showNotification('success', message),
    error: message => showNotification('error', message),
    info: message => showNotification('info', message),
    warning: message => showNotification('warning', message),
  };

  const showNotification = (severity: Severity, msg: string) => {
    setSnackOpen({
      open: true,
      severity: severity,
      msg: msg
    })
  }

  const value: MessageContextValue = {
    notificationHandler
  };

  return (
      <MessageContext.Provider value={value}>
        <RTL>
        <Snackbar
            anchorOrigin={{vertical: "bottom", horizontal: "center"}}
            open={snackOpen.open}
                  autoHideDuration={3000}
                  onClose={() => setSnackOpen({
                    open: false,
                    severity: snackOpen.severity,
                    msg: ''
                  })}>

          <Alert onClose={() => setSnackOpen({
            open: false,
            severity: snackOpen.severity,
            msg: ''
          })} severity={snackOpen.severity} sx={{ width: '100%' }}>
            {snackOpen.msg}
          </Alert>
        </Snackbar>
        </RTL>
        {children}
      </MessageContext.Provider>
  );
}
